if($('.type-detail').length){

    $('#product-detail-form').append('<div class="cart-wrap-custom"><div class="left"></div><div class="right"></div></div>')
    $('.p-price-wrapper').appendTo('.cart-wrap-custom .left')
    $('.p-to-cart-block').appendTo('.cart-wrap-custom .left')
    $('img[alt="banner-top"]').insertAfter('header#header').wrap('<div class="text-center top-banner"></div>')
    $('img[alt="banner-bottom"]').insertAfter('.benefit-banners-full-width').wrap('<div class="text-center bottom-banner"></div>')
    $('.extended-description tr').each(function(){
        if($(this).text().match('Vydavateľstvo')){
            $('.cart-wrap-custom .right').append('<div class="flexik vydavatelstvi"><span class="title">Vydavateľstvo</span><span class="text"><span class="blue">'+$(this).find('td').text().split(',')[0]+'</span>,'+$(this).find('td').text().split(',')[1]+'</span></div>')
        }
        if($(this).text().match('Počet strán')){
            $('.cart-wrap-custom .right').append('<div class="flexik vydavatelstvi"><span class="title">Počet strán</span><span class="text">'+$(this).find('td').text()+'</span></div>')
        }
    })
    var currentSku = $('#product-detail-form meta[itemprop="sku"]').attr('content');
    $('.benefitBanner__data>div').each(function() {
        if ($(this).attr('data-code-id') !== currentSku) {
            $(this).remove();
        }
    });
    
}
